module.exports = __webpack_public_path__ + "img/LoGoEDM.0707b0b7.png";